import { createContext, useContext } from 'react';

export const SidebarNavigationGroupContext = createContext<boolean>(false);

export const useIsInSidebarNavigationGroup = () => {
  return useContext(SidebarNavigationGroupContext);
};
